import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Menu } from '@pocketlaw/tetris';
import { ColumnIcon } from './ColumnIcon';
import { ColumnToggle } from './ColumnToggle';
import { ColumnItemContainer } from './styled';
export function SortableItem(props) {
    const { id, children, disabled, active, onToggle } = props;
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id,
        disabled,
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    return (<Menu.Item render={<ColumnItemContainer as="div" ref={setNodeRef} style={style} disabled={disabled} {...attributes}>
          <Box gap="sm" width="100%" style={{ overflow: 'hidden' }} {...listeners}>
            <ColumnIcon active={active}/>
            <Menu.ItemText primary={children}/>
          </Box>
          <ColumnToggle active={active} onClick={onToggle}/>
        </ColumnItemContainer>}/>);
}
